import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import SectionLabel from "../site/SectionLabel";
import { HOME_SECTIONS } from "@/constants/testIds";
import { INSIGHTS } from "@/lib/data";

function fmt(dateStr) {
  const d = new Date(dateStr);
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export default function Insights() {
  return (
    <section
      data-testid={HOME_SECTIONS.insights}
      className="relative bg-ink-950 py-28 lg:py-40"
    >
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div>
            <SectionLabel number="12">Insights</SectionLabel>
            <h2 className="mt-6 max-w-3xl font-display text-5xl leading-[0.98] tracking-tighter text-ivory lg:text-7xl">
              Field notes on design<br />
              <span className="italic text-gold">and business.</span>
            </h2>
          </div>
          <Link
            to="/insights"
            className="group inline-flex items-center gap-3 self-start font-sans text-[12px] uppercase tracking-widest text-gold hover:text-ivory transition-colors md:self-end"
          >
            All insights
            <span className="h-px w-8 bg-current transition-all group-hover:w-12" />
          </Link>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-x-8 gap-y-10 md:grid-cols-2 lg:grid-cols-4">
          {INSIGHTS.map((post, i) => (
            <motion.article
              key={post.slug}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
            >
              <Link
                to={`/insights/${post.slug}`}
                className="group flex h-full flex-col border-t border-ivory/[0.06] pt-6"
              >
                <div className="flex items-center justify-between font-sans text-[11px] uppercase tracking-widest text-gold">
                  <span>{post.category}</span>
                  <span className="text-ivory-dim">{post.readMinutes} min</span>
                </div>
                <h3 className="mt-6 flex-1 font-display text-2xl leading-[1.1] tracking-tight text-ivory transition-colors group-hover:text-gold lg:text-3xl">
                  {post.title}
                </h3>
                <p className="mt-4 font-sans text-sm text-ivory-muted line-clamp-3">
                  {post.excerpt}
                </p>
                <div className="mt-6 font-sans text-[11px] uppercase tracking-widest text-ivory-dim">
                  {fmt(post.date)}
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
